/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Save_Mock_2Inputs */

const en_cap_save_mock_2 = /** @type {(inputs: Cap_Save_Mock_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy of the March invoice`)
};

const lv_cap_save_mock_2 = /** @type {(inputs: Cap_Save_Mock_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marta rēķina kopija`)
};

/**
* | output |
* | --- |
* | "Copy of the March invoice" |
*
* @param {Cap_Save_Mock_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_save_mock_2 = /** @type {((inputs?: Cap_Save_Mock_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Save_Mock_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_save_mock_2(inputs)
	return en_cap_save_mock_2(inputs)
});